// COMMON MESSAGES
export const UNKNOWN_ERROR_OCCURED = "Unknown Error occured! Please try again"
export const ERROR_WHILE__NAME = "Error occured in API -"
// example:- console.log(`${ERROR_WHILE__NAME} apiName `, err.message)


// PRODUCTS PAGES
export const ERROR_WHILE_FETCHING_PRODUCTS = "Unable to load Products. Please try again."
export const ERROR_WHILE_DELETING_PRODUCTS = "No details found"
export const CONFIRMATION_BEFORE_DELETING_PRODUCT = "Are you sure you want to delete this product?"
export const PRODUCT_DELETED_SUCCESSFULLY = "Product is deleted successfully."
export const PRODUCT_STATUS_CHANGED_SUCCESSFULLY = "Product status changed successfully."
// create
export const PRODUCT_ADDED_SUCCESSFULLY = "Product created successfully."
export const ERROR_WHILE_CREATING_PRODUCT = "Error occured!! Please check if all the required fields are filled correctly."
// edit
export const PRODUCT_UPDATED_SUCCESSFULLY = "Product Updated successfully."
export const ERROR_WHILE_UPDATING_PRODUCT = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_PRODUCT_DETAILS = "Unable to get the user details. Please try again"


// CATEGORIES PAGES
export const ERROR_WHILE_FETCHING_CATEGORIES = "Unable to load Categories. Please try again."
export const ERROR_WHILE_DELETING_CATEGORY = "No details found."
export const CONFIRMATION_BEFORE_DELETING_CATEGORY = "Are you sure you want to delete this category?"
export const CATEGORY_DELETED_SUCCESSFULLY = "Category deleted successfully."
// create
export const CATEGORY_ADDED_SUCCESSFULLY = "Category created successfully."
export const ERROR_WHILE_CREATING_CATEGORY = "Error occured!! Please check if all the required fields are filled correctly."
// edit
export const CATEGORY_UPDATED_SUCCESSFULLY = "Category Updated successfully."
export const ERROR_WHILE_UPDATING_CATEGORY = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_CATEGORY_DETAILS = "Unable to get the category details. Please try again"


// BRANDS PAGES
export const ERROR_WHILE_FETCHING_BRANDS = "Unable to load Brands. Please try again."
export const ERROR_WHILE_DELETING_BRAND = "No details found."
export const CONFIRMATION_BEFORE_DELETING_BRAND = "Are you sure you want to delete this brand?"
export const BRAND_DELETED_SUCCESSFULLY = "Brand deleted successfully."
// create
export const BRAND_ADDED_SUCCESSFULLY = "Brand created successfully."
export const ERROR_WHILE_CREATING_BRAND = "Error occured!! Please check if all the required fields are filled correctly."
// // edit
export const BRAND_UPDATED_SUCCESSFULLY = "Brand Updated successfully."
export const ERROR_WHILE_UPDATING_BRAND = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_BRAND_DETAILS = "Unable to get the brand details. Please try again"


// COUPON PAGES
export const ERROR_WHILE_FETCHING_COUPONS = "Unable to load Coupons. Please try again."
export const ERROR_WHILE_DELETING_COUPON = "No details found."
export const CONFIRMATION_BEFORE_DELETING_COUPON = "Are you sure you want to delete this coupon?"
export const COUPON_DELETED_SUCCESSFULLY = "Brand deleted successfully."
// create
export const COUPON_ADDED_SUCCESSFULLY = "Brand created successfully."
export const ERROR_WHILE_CREATING_COUPON = "Error occured!! Please check if all the required fields are filled correctly."
// // edit
export const COUPON_UPDATED_SUCCESSFULLY = "Brand Updated successfully."
export const ERROR_WHILE_UPDATING_COUPON = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_COUPON_DETAILS = "Unable to get the coupons details. Please try again"


// USER PAGES
export const ERROR_WHILE_FETCHING_USERS = "Unable to load Users. Please try again."
export const ERROR_WHILE_DELETING_USER = "No details found."
export const CONFIRMATION_BEFORE_DELETING_USER = "Are you sure you want to delete this user?"
export const USER_DELETED_SUCCESSFULLY = "User deleted successfully."
// create
export const USER_ADDED_SUCCESSFULLY = "User created successfully."
export const ERROR_WHILE_CREATING_USER = "Error occured!! Please check if all the required fields are filled correctly."
// // edit
export const USER_UPDATED_SUCCESSFULLY = "User Updated successfully."
export const ERROR_WHILE_UPDATING_USER = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_USER_DETAILS = "Unable to get the users details. Please try again"

// CUSTOMER PAGES
export const ERROR_WHILE_FETCHING_CUSTOMERS = "Unable to load Customers. Please try again."
export const ERROR_WHILE_DELETING_CUSTOMER = "No details found."
export const CONFIRMATION_BEFORE_DELETING_CUSTOMER = "Are you sure you want to delete this customer?"
export const CUSTOMER_DELETED_SUCCESSFULLY = "Customer deleted successfully."

// create
export const CUSTOMER_ADDED_SUCCESSFULLY = "Customer created successfully."
export const ERROR_WHILE_CREATING_CUSTOMER = "Error occured!! Please check if all the required fields are filled correctly."

// edit
export const CUSTOMER_UPDATED_SUCCESSFULLY = "Customer Updated successfully."
export const ERROR_WHILE_UPDATING_CUSTOMER = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_CUSTOMER_DETAILS = "Unable to get the customer details. Please try again"

//ADD CUSTOMER 
export const ERROR_WHILE_FETCHING_ADDRESS = "Unable to load Customers. Please try again."
export const ERROR_WHILE_DELETING_ADDRESS = "No details found."
export const CONFIRMATION_BEFORE_DELETING_ADDRESS = "Are you sure you want to delete this address?"
export const ADDRESS_DELETED_SUCCESSFULLY = "Address deleted successfully."
export const SET_ADDRESS_DEFAULT_SUCCESSFULLY = "Set Address as default successfully."
export const ERROR_WHILE_SET_ADDRESS_DEFAULT = "Error occured!! Please check if all the required fields are filled correctly."

// create address
export const ADDRESS_ADDED_SUCCESSFULLY = "Address added successfully."
export const ERROR_WHILE_CREATING_ADDRESS = "Error occured!! Please check if all the required fields are filled correctly."

// edit address
export const ADDRESS_UPDATED_SUCCESSFULLY = "Address Updated successfully."
export const ERROR_WHILE_UPDATING_ADDRESS = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_ADDRESS_DETAILS = "Unable to get the address details. Please try again"


// EMAILS PAGES
export const ERROR_WHILE_FETCHING_EMAILS = "Unable to load Email Templates. Please try again."
export const ERROR_WHILE_DELETING_EMAIL = "No details found."
export const CONFIRMATION_BEFORE_DELETING_EMAIL = "Are you sure you want to delete this email template?"
export const EMAIL_DELETED_SUCCESSFULLY = "Email Template deleted successfully."
export const EMAIL_STATE_CHANGED_SUCCESSFULLY = "Status changed successfully."
// create
export const EMAIL_ADDED_SUCCESSFULLY = "Email created successfully."
export const ERROR_WHILE_CREATING_EMAIL = "Error occured!! Please check if all the required fields are filled correctly."
// // edit
export const EMAIL_UPDATED_SUCCESSFULLY = "Email Updated successfully."
export const ERROR_WHILE_UPDATING_EMAIL = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_EMAIL_DETAILS = "Unable to get the emails details. Please try again"


// BLOGS PAGES
export const ERROR_WHILE_FETCHING_BLOGS = "Unable to load Blogs. Please try again."
export const ERROR_WHILE_DELETING_BLOG = "No details found."
export const CONFIRMATION_BEFORE_DELETING_BLOG = "Are you sure you want to delete this blog?"
export const BLOG_DELETED_SUCCESSFULLY = "Blog deleted successfully."
// create
export const BLOG_ADDED_SUCCESSFULLY = "Blog created successfully."
export const ERROR_WHILE_CREATING_BLOG = "Error occured!! Please check if all the required fields are filled correctly."
// // edit
export const BLOG_UPDATED_SUCCESSFULLY = "Blog Updated successfully."
export const ERROR_WHILE_UPDATING_BLOG = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_BLOG_DETAILS = "Unable to get the blog detail. Please try again"


// CUSTOMER GROUPS PAGES
export const ERROR_WHILE_FETCHING_CUSTOMERGROUPS = "Unable to load Customer Groups. Please try again."
export const ERROR_WHILE_DELETING_CUSTOMERGROUP = "No details found."
export const CONFIRMATION_BEFORE_DELETING_CUSTOMERGROUP = "Are you sure you want to delete this customer group?"
export const CUSTOMERGROUP_DELETED_SUCCESSFULLY = "Customer Group deleted successfully."
// create
export const CUSTOMERGROUP_ADDED_SUCCESSFULLY = "Customer Group created successfully."
export const ERROR_WHILE_CREATING_CUSTOMERGROUP = "Error occured!! Please check if all the required fields are filled correctly."
// // edit
export const CUSTOMERGROUP_UPDATED_SUCCESSFULLY = "Customer Group Updated successfully."
export const ERROR_WHILE_UPDATING_CUSTOMERGROUP = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_CUSTOMERGROUP_DETAILS = "Unable to get the customer group detail. Please try again"

// VARIATIONS PAGES
// create
export const VARIATIONS_ADDED_SUCCESSFULLY = "Variation added successfully."
export const ERROR_WHILE_CREATING_VARIATIONS = "Error occured!! Please try again."

// ProductFilters
export const PRODUCTFILTERS_UPDATED_SUCCESSFULLY = "Product Filter updated successfully."
export const ERROR_WHILE_FETCHING_PRODUCTFILTERS = "Unable to load Product Filters. Please try again."
export const ERROR_WHILE_UPDATING_PRODUCTFILTERS = "Error occured!! please check if all the required fields are filled correctly."


// Multipliers
export const MULTIPLIERS_UPDATED_SUCCESSFULLY = "Multipliers added successfully."
export const ERROR_WHILE_FETCHING_MULTIPLIERS = "Unable to load Multipliers. Please try again."

// Product Multipliers
export const PRODUCT_MULTIPLIERS_UPDATED_SUCCESSFULLY = "Product Multipliers Updated successfully."
export const ERROR_WHILE_UPDATING_PRODUCT_MULTIPLIERS = "Error occured!! please check if all the required fields are filled correctly."

// Brand Multipliers
export const BRAND_MULTIPLIERS_UPDATED_SUCCESSFULLY = "Brand Multipliers Updated successfully."
export const ERROR_WHILE_UPDATING_BRAND_MULTIPLIERS = "Error occured!! please check if all the required fields are filled correctly."

// Category Multipliers
export const CATEGORY_MULTIPLIERS_UPDATED_SUCCESSFULLY = "Category Multipliers Updated successfully."
export const ERROR_WHILE_UPDATING_CATEGORY_MULTIPLIERS = "Error occured!! please check if all the required fields are filled correctly."

//Quickbook Settings
export const QUICKBOOKS_SETTINGS_UPDATED_SUCCESSFULLY = "Settings updated successfully."
export const ERROR_WHILE_FETCHING_QUICKBOOKS_SETTINGS = "Unable to load settings. Please try again."

// VENDORS PAGES
export const ERROR_WHILE_FETCHING_VENDORS = "Unable to load Vendors. Please try again."
export const ERROR_WHILE_DELETING_VENDORS = "No details found"
export const CONFIRMATION_BEFORE_DELETING_VENDOR = "Are you sure you want to delete this vendor?"
export const VENDOR_DELETED_SUCCESSFULLY = "Vendor is deleted successfully."
// create
export const VENDOR_ADDED_SUCCESSFULLY = "Vendor created successfully."
export const ERROR_WHILE_CREATING_VENDOR = "Error occured!! Please check if all the required fields are filled correctly."
// edit
export const VENDOR_UPDATED_SUCCESSFULLY = "Vendor Updated successfully."
export const ERROR_WHILE_UPDATING_VENDOR = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_VENDOR_DETAILS = "Unable to get the vendor details. Please try again"

// Cart PAGES
export const ERROR_WHILE_FETCHING_CART = "Unable to load Cart. Please try again."
export const ERROR_WHILE_DELETING_CART = "No details found"
export const CONFIRMATION_BEFORE_DELETING_CART = "Are you sure you want to delete this cart?"
export const CART_DELETED_SUCCESSFULLY = "Cart is deleted successfully."
// create
export const CART_ADDED_SUCCESSFULLY = "Cart created successfully."
export const ERROR_WHILE_CREATING_CART = "Error occured!! Please check if all the required fields are filled correctly."
// edit
export const CART_UPDATED_SUCCESSFULLY = "Cart Updated successfully."
export const ERROR_WHILE_UPDATING_CART = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_CART_DETAILS = "Unable to get the vendor details. Please try again"

//create coupon
export const COUPON__ADDED_SUCCESSFULLY = "Coupon created successfully."
export const ERROR_WHILE_CREATING__COUPON = "Error occured!! Please check if all the required fields are filled correctly."

//create order
export const ORDER__ADDED_SUCCESSFULLY = "Order created successfully."
export const ERROR_WHILE_CREATING_ORDER = "Error occured!! Please check if all the required fields are filled correctly."

// PRODUCT TYPE PAGES
export const ERROR_WHILE_FETCHING_PRODUCTTYPES = "Unable to load Product Types. Please try again."
export const ERROR_WHILE_DELETING_PRODUCTTYPE = "No details found."
export const CONFIRMATION_BEFORE_DELETING_PRODUCTTYPE = "Are you sure you want to delete this product type?"
export const PRODUCTTYPE_DELETED_SUCCESSFULLY = "Product Type deleted successfully."
// create
export const PRODUCTTYPE_ADDED_SUCCESSFULLY = "Product Type created successfully."
export const ERROR_WHILE_CREATING_PRODUCTTYPE = "Error occured!! Please check if all the required fields are filled correctly."
// // edit
export const PRODUCTTYPE_UPDATED_SUCCESSFULLY = "Product Type Updated successfully."
export const ERROR_WHILE_UPDATING_PRODUCTTYPE = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_PRODUCTTYPE_DETAILS = "Unable to get the product type detail. Please try again"

// PAYMENT INTEGRATIONS PAGES
export const ERROR_WHILE_FETCHING_PAYMENTINTEGRATION = "Unable to load payment integrations. Please try again."
export const ERROR_WHILE_DELETING_PAYMENTINTEGRATION = "No details found."
export const CONFIRMATION_BEFORE_DELETING_PAYMENTINTEGRATION = "Are you sure you want to delete this payment integrations?"
export const PAYMENTINTEGRATION_DELETED_SUCCESSFULLY = "Payment integrations deleted successfully."
// create
export const PAYMENTINTEGRATION_ADDED_SUCCESSFULLY = "Payment integrations created successfully."
export const ERROR_WHILE_CREATING_PAYMENTINTEGRATION = "Error occured!! Please check if all the required fields are filled correctly."
// // edit
export const PAYMENTINTEGRATION_UPDATED_SUCCESSFULLY = "Payment integrations Updated successfully."
export const ERROR_WHILE_UPDATING_PAYMENTINTEGRATION = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_PAYMENTINTEGRATION_DETAILS = "Unable to get the payment integrations detail. Please try again"

// sales orders
export const ERROR_WHILE_GETTING_ORDER_DETAILS = "Unable to get order details. Please try again."

//shippings
export const ERROR_WHILE_FETCHING_SHIPPINGS = "Unable to load shippings. Please try again."
export const ERROR_WHILE_DELETING_SHIPPING = "No details found"
export const CONFIRMATION_BEFORE_DELETING_SHIPPING = "Are you sure you want to delete this shipping?"
export const SHIPPING_DELETED_SUCCESSFULLY = "Shipping is deleted successfully."
// create
export const SHIPPING_ADDED_SUCCESSFULLY = "Shipping created successfully."
export const ERROR_WHILE_CREATING_SHIPPING = "Error occured!! Please check if all the required fields are filled correctly."
// edit
export const SHIPPING_UPDATED_SUCCESSFULLY = "Shipping Updated successfully."
export const ERROR_WHILE_UPDATING_SHIPPING = "Error occured!! please check if all the required fields are filled correctly."
export const ERROR_WHILE_GETTING_SHIPPING_DETAILS = "Unable to get the vendor details. Please try again"

export const getError = (res, message = "") => {
    let error = ""
    if (typeof res === 'string' || res instanceof String) {
        error = res
    } else {
        Object.keys(res).forEach(function (key) {
            if (!error) {
                const er = res[key]
                if (typeof er === 'string' || er instanceof String) {
                    error = er
                } else {
                    error = er[0] || ""
                }
            }
        });
    }
    console.log(error)
    return error || message
}

// notifications
export const ADD_DOMAIN_FIRST = "Please add a domain name first."
export const LOGO_ADDED_SUCCESSFULLY = "Logo added successfully."
export const DOMAIN_ADDED_SUCCESSFULLY = "Domain added successfully"
export const DOMAIN_DELETED_SUCCESSFULLY = "Domain deleted successfully"
export const SENDERS_NAME_AND_EMAIL_UPDATED_SUCCESSFULLY = "Details update successfully"
export const ADMIN_EMAIL_ADDED_SUCCESSFULLY = "Emails added successfully"